import { render, staticRenderFns } from "./RealestateForm.vue?vue&type=template&id=e0708916&scoped=true&"
import script from "./RealestateForm.vue?vue&type=script&lang=js&"
export * from "./RealestateForm.vue?vue&type=script&lang=js&"
import style0 from "./RealestateForm.vue?vue&type=style&index=0&id=e0708916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0708916",
  null
  
)

export default component.exports